/**
 *
 * @param {number} avgRating Raw rating e.g. 1.123, 2.345.
 * @return {string} Raw rating rounded to 0 or 5 e.g. 1.0, 2.5.
 */
export const getRating = (avgRating) => (Math.round(avgRating * 2) / 2).toFixed(1);

/**
 *
 * @param {number\|string} roundedRating A rounded rating value e.g. 1.0, 1.5, 2.0, ...
 * @return {string} 1.0 => 1-0, 1.5 => 1-5, 2.0 => 2-0, ...
 */
export const convertRatingDecimalToDash = (roundedRating) => {
    return roundedRating.toString().replace('.0', '').replace('.5', '-5');
};

/**
 *
 * @param {string\|number} size Map string inputs lg and sm to expected pixel size otherwise output argument in pixels.
 * @return {string} Size in pixels.
 */
export const getSizeInPixels = (size) => {
    switch (size) {
        case 'lg':
            return '24px';
        case 'sm':
            return '12px';
        default:
            return `${size}px`;
    }
};
